import type { ReportSettingsTemplateTargetsResponse } from "@common/schemas/domains/reportSettings/report-settings-template-application.schema";
import { getReportTemplateFilterKey } from "@common/helpers/report-settings/report-template-filter-key";
import { resolveInheritedReportTemplate } from "@common/helpers/report-settings/resolve-inherited-report-template";

export type TargetFacts =
    ReportSettingsTemplateTargetsResponse["workspaces"][number];

export const isOwnedByAnotherFirm = (facts: TargetFacts) =>
    facts.blockReason === "ownedByAnotherFirm";

const getDirectTemplateKey = (facts: TargetFacts | undefined) =>
    facts?.appliedTemplate
        ? getReportTemplateFilterKey(facts.appliedTemplate.templateId)
        : null;

export const getSavedTemplateKey = ({
    facts,
    clientFacts,
    defaultTemplateKey,
}: {
    facts: TargetFacts;
    clientFacts: TargetFacts | undefined;
    defaultTemplateKey: string;
}) => {
    if (
        !clientFacts ||
        isOwnedByAnotherFirm(facts) ||
        isOwnedByAnotherFirm(clientFacts)
    ) {
        return null;
    }
    return resolveInheritedReportTemplate({
        entity: getDirectTemplateKey(facts),
        workspace: getDirectTemplateKey(clientFacts),
        firmDefault: defaultTemplateKey,
    }).value;
};

export const indexTargetFacts = (
    targets: ReportSettingsTemplateTargetsResponse,
) => ({
    workspaceFactsById: new Map(
        targets.workspaces.map((facts) => [facts.workspaceId, facts]),
    ),
    entityFactsById: new Map(
        targets.entities.map((facts) => [facts.entityId, facts]),
    ),
});
